import PropTypes from 'prop-types';
import { Row, Col } from '../../utils/grid/Grid';
import HostTeaserSmall from './HostTeaserSmall';

const HostTeaserSmallList = ({ hosts, showPrices }) => (
  <Row>
    {hosts.map((host, index) => (
      <Col xs={12} sm={6} md={3} key={index}>
        <HostTeaserSmall {...host} showPrices={showPrices} renderPriceAlternatives={false} />
      </Col>
    ))}
  </Row>
);

HostTeaserSmallList.propTypes = {
  hosts: PropTypes.arrayOf(PropTypes.object).isRequired,
  showPrices: PropTypes.bool,
};

HostTeaserSmallList.defaultProps = {
  showPrices: true,
};

export default HostTeaserSmallList;
